import styled from 'styled-components';

export const Photo = styled.img`
  width: 100%;
  margin-top: ${props => props.theme.margin};
`;



// WEBPACK FOOTER //
// ./components/MealPhoto/MealPhoto.style.js